import React, { useEffect, useState } from 'react'
import { get } from '../../util/request';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../redux/action/auth.action';

const TugasKerja = (props) => {
  const [state, setState] = useState({
    tasksList: '',
    loading: true
  })

  const dispatch = useDispatch();


  const jwtToken = useSelector(state => state.auth.generateToken)
  const user = useSelector(state => state.auth.user)



  useEffect(() => {
    let isMounted = true
    if (isMounted){
      getTasksList()
    }
    return () => isMounted === false
			// eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  const getTasksList  = () => {
    get(
      `public/api/v2/project-list?company_id=${user.company_id}&employee_id=${user.employee_id}`,
      {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          'Content-Type': 'application/json'
        },      
      },
      success => {
        setState(prevState => {
          return {
            ...prevState,
            tasksList: success.data.Data,
            loading: false
          }
        })
      },
      error => {
        if (error.status === 401) {
          dispatch(logout())
        }
        setState(prevState => {
          return {
            ...prevState,
            loading: false
          }
        })
        console.log('error request', error)
      }
    )
  }

  return (
  state.loading ? '' :
    <div className='w-full h-screen grid-cols-1 sm:grid-cols-2 bg-real-white'>
      <div className='w-full h-20 bg-real-white'>
        <div className='flex items-center h-full px-4'>
          <a href={process.env.PUBLIC_URL + "/home"}>
            <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/arrow-left.svg"} className='justify-start w-10 py-1' />
          </a>
          <p className='px-4'>Daftar Tugas Kerja</p>
        </div>
      </div>
      <div className='w-full px-4 bg-real-white'>
      {state.loading ? "" : state.tasksList.length === 0 ? <p className='py-32 text-center text-gray-400'>Daftar Tugas Kerja kosong</p> :  state.tasksList?.map((item, index) => (
        <a href={process.env.PUBLIC_URL + "/tugas-kerja/" + item.company_project_id} className='flex justify-between w-full h-full gap-2 py-4 border-b-2 border-gray-200'>
        <img alt='logo_home' src={item.company_project_logo == null ? process.env.PUBLIC_URL + "/assets/img/checklist.svg": process.env.PUBLIC_URL + "/assets/img/"+ item.company_project_logo} className='w-1/12 h-6 text-center'/>
          <p className='w-full px-4'>{item.company_project_name}</p>
          <div className='w-1/5 px-4 py-1 text-xs font-bold text-center border rounded' 
            style={{backgroundColor: item.status_text === 'DONE' ? '#3AAD04' : 'white', color: item.status_text === 'DONE' ? 'white' : 'black', borderColor: item.status_text === 'DONE' ? '#3AAD04' : 'black'}}>{item.status_text}</div>
        </a>
							))}
      </div>
    </div >
  )
}

export default TugasKerja